import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { LinkButtonBase } from '@/components/ui/Button/LinkButtonBase';
import { outlineButtonColors, outlineButtonTextColors, } from '@/components/ui/Button/OutlineButton';
/**
 * 共通：ボタンリンクコンポーネント（ボーダー白抜き）
 * @param props
 * @constructor
 */
export const OutlineLinkButton = (props) => {
    const { children, className = '', color, disabled, externalLinkAttributes, isFull, onClick, routerLinkAttributes, size, target, textClassName, to, } = props;
    const shadow = 'drop-shadow-sm active:drop-shadow-none';
    return (_jsx(LinkButtonBase, Object.assign({ className: clsx(outlineButtonTextColors[color], outlineButtonColors[color].bg, outlineButtonColors[color].border, shadow, className), disabled: disabled, externalLinkAttributes: externalLinkAttributes, isFull: isFull, onClick: onClick, routerLinkAttributes: routerLinkAttributes, size: size, target: target, textClassName: textClassName, textColor: 'none', to: to }, { children: children })));
};
